import React from "react";
import { FILE_AUTH_URL } from "../../Shared/constant";
import { Badge } from "./ui/badge";
import { formatDateTime, humaniseCode } from "./d2cFormat";

// The OMS returns its own file route ("view/file/<id>"), the same one the dealer
// registration screen shows photos through, so the link is built the same way.
export const photoHref = (url) => (url ? FILE_AUTH_URL + String(url).replace(/^\/+/, "") : null);

const PdiPhotos = ({ photos = [] }) => {
  if (!photos.length) {
    return <div className="tw-text-sm tw-text-muted-foreground">No PDI photos yet.</div>;
  }
  return (
    <div className="tw-grid tw-grid-cols-2 tw-gap-3 sm:tw-grid-cols-3">
      {photos.map((photo, index) => {
        const href = photoHref(photo.url);
        return (
          <figure key={`${photo.kind}-${index}`} className="tw-m-0 tw-flex tw-flex-col tw-gap-1">
            <a href={href} target="_blank" rel="noopener noreferrer" title="Open the full photo">
              <img
                src={href}
                alt={`PDI ${photo.label || humaniseCode(photo.kind)}`}
                loading="lazy"
                className="tw-aspect-square tw-w-full tw-rounded-md tw-border tw-object-cover"
              />
            </a>
            <figcaption className="tw-flex tw-flex-wrap tw-items-center tw-gap-1 tw-text-xs tw-text-muted-foreground">
              <span className="tw-font-medium tw-text-foreground">{photo.label || humaniseCode(photo.kind)}</span>
              <span>{formatDateTime(photo.captured_at)}</span>
              {photo.quality_ok === false && (
                <Badge tone="warning">Low quality{photo.quality_reason ? `: ${humaniseCode(photo.quality_reason)}` : ""}</Badge>
              )}
              {photo.submitted === false && <Badge tone="neutral">Not submitted</Badge>}
            </figcaption>
          </figure>
        );
      })}
    </div>
  );
};

export default PdiPhotos;
